import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';

let config = new SvgFactoryConfig();
config.iconName = "print-widget";
config.viewBox="0 0 19 17";
config.shape = `
    <g fill="var(--fill)" fill-rule="evenodd">
        <path fill="var(--fill-path1)" fill-rule="nonzero" d="M17.538 3.636H1.462C.654 3.636 0 4.287 0 5.091v6.545c0 .804.654 1.455 1.462 1.455h2.192V7.273h11.692v5.818h2.192c.808 0 1.462-.651 1.462-1.455V5.091c0-.804-.654-1.455-1.462-1.455z"/>
        <path stroke="var(--stroke-path2)" stroke-width="var(--stroke-width-path2)" d="M3.654 7.273h11.692V16H3.654z"/>
        <path fill="var(--fill-path3)" fill-rule="nonzero" d="M16.077 2.182H2.923V.727A.73.73 0 0 1 3.653 0h11.693a.73.73 0 0 1 .73.727v1.455z"/>
    </g>
`;
let PrintWidgetSVG = new SvgFactory(config);

export default PrintWidgetSVG;

